'use client'

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { useState, useEffect } from "react"
import { Menu, X } from "lucide-react"
import { BrandLink } from "./brand-link"
import { business } from "@/lib/business"
import { cn } from "@/lib/utils"

export function Header() {
    const [isOpen, setIsOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)

    // Handle scroll
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0)
        }

        window.addEventListener('scroll', handleScroll)
        handleScroll() // Check initial scroll position

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    // Close menu when clicking a link
    const handleLinkClick = () => {
        setIsOpen(false)
    }

    // Prevent scrolling when menu is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [isOpen])

    return (
        <>
            <header className={cn(
                "fixed top-0 z-[200] w-full transition-colors duration-200",
                isScrolled ? "bg-black/95 backdrop-blur supports-[backdrop-filter]:bg-black/60" : "bg-transparent"
            )}>
                <div className="container flex flex-row-reverse h-16 items-center justify-between relative md:px-32">
                    <div className="h-px w-20 bg-white/50 hidden md:block"></div>
                    <nav className="hidden md:flex justify-between w-1/2 mx-auto py-4">
                        {business.navigation.main.map((item) => (
                            <Link
                                key={item.href}
                                href={item.href}
                                className="text-xs text-white font-sans uppercase tracking-wider transition-colors hover:text-white/70"
                            >
                                {item.name}
                            </Link>
                        ))}
                    </nav>
                    <div className="h-px w-20 bg-white/50 hidden md:block"></div>
                    <div className="flex items-center gap-4">

                        <Button
                            variant="outline"
                            size="icon"
                            className="md:hidden rounded-none border-transparent relative z-50 text-white bg-transparent"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span className="sr-only">Menü {isOpen ? 'schließen' : 'öffnen'}</span>
                            {isOpen ? (
                                <X className="h-6 w-6" />
                            ) : (
                                <Menu className="h-6 w-6" />
                            )}
                        </Button>
                    </div>
                    <BrandLink className="md:hidden" />
                </div>
            </header>

            {/* Mobile Menu Overlay */}
            <div
                className={`
                    fixed inset-0 bg-black z-[100] md:hidden
                    transition-opacity duration-300 ease-in-out
                    ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}
                `}
            >
                <div className="container h-full flex flex-col pt-24 pb-8">
                    <nav className="flex flex-col gap-6">
                        {business.navigation.main.map((item) => (
                            <Link
                                key={item.href}
                                href={item.href}
                                className="text-md text-white font-sans uppercase tracking-wider transition-colors hover:text-white/70"
                                onClick={handleLinkClick}
                            >
                                {item.name}
                            </Link>
                        ))}
                        <Button asChild className="mt-4 bg-white hover:bg-white/90 text-black rounded-none w-full">
                            <Link href="/#contact" onClick={handleLinkClick}>
                                Anfrage stellen
                            </Link>
                        </Button>
                    </nav>
                </div>
            </div>
        </>
    )
} 